module.exports = __webpack_public_path__ + "static/childcouncil_img1@2x-bdec6cc646b4230cad4d17687d8a66bc.jpg";